import i18n from 'helpers/i18n';
import messages from './messages';
import { toast } from 'react-toastify';
import { Toast, ToastProps } from './Toast';

function toastError(props: ToastProps = {}) {
  toast(
    <Toast
      title={i18n.ft(messages.error.title)}
      description={i18n.ft(messages.error.description)}
      icon={{ name: 'times circle', color: 'red' }}
      {...props}
    />
  );
}

export default toastError;
